export * from './lib/menu-rio-feature-shell.module';
